import { render } from "./OrderStaffCard.vue?vue&type=template&id=988f203e"
import script from "./OrderStaffCard.vue?vue&type=script&lang=js"
export * from "./OrderStaffCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__